import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone } from '@fortawesome/free-solid-svg-icons';
import './DefaultTemplates.css';

const DefaultTemplates = ({ onSelectTemplate }) => {
  const [defaultTemplates, setDefaultTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDefaultTemplates = async () => {
      try {
        setLoading(true);
        const templatesCollectionRef = collection(db, 'defaultTemplates');
        const querySnapshot = await getDocs(templatesCollectionRef);
        
        const templates = [];
        querySnapshot.forEach((doc) => {
          templates.push({
            id: doc.id,
            ...doc.data()
          });
        });
        
        setDefaultTemplates(templates);
      } catch (err) {
        console.error('Error fetching default templates:', err);
        setError('Failed to load default templates');
      } finally {
        setLoading(false);
      }
    };

    fetchDefaultTemplates();
  }, []);

  const handleUseTemplate = (template) => {
    if (onSelectTemplate) {
      onSelectTemplate(template);
    }
  };

  if (loading) {
    return <div className="default-templates-loading">Loading default templates...</div>;
  }

  if (error) {
    return <div className="default-templates-error">{error}</div>;
  }

  if (defaultTemplates.length === 0) {
    return <div className="default-templates-empty">No default templates available.</div>;
  }

  return (
    <div className="default-templates-container">
      <h3 className="default-templates-title">Default Templates</h3>
      <div className="default-templates-list">
        {defaultTemplates.map((template) => (
          <div key={template.id} className="default-template-item">
            <div className="default-template-info">
              <span className="default-template-name">{template.name}</span>
              <span className="default-template-segments-count">
                {template.segments.length} {template.segments.length === 1 ? 'segment' : 'segments'}
              </span>
            </div>
            <button 
              className="default-template-use-btn"
              onClick={() => handleUseTemplate(template)}
              title="Use this template"
            >
              <FontAwesomeIcon icon={faClone} /> Use
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DefaultTemplates;